import React, { useEffect } from 'react';

function Impressum() {


    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
    }, []);

    return <div className="container">

        {/* page Title */}
        <div className="row mt-5 mb-5 text-center">
            <h3>Impressum</h3>
        </div>

        <div className="row mb-3">
            <h5 className="mb-4">Angaben gemäß § 5 TMG:</h5>

            <h5 className="pb-0 mb-0">KAZA Sprachdienste</h5>
            <p className="mb-0">Hans-Poeche-Straße 5</p>
            <p>04103 Leipzig</p>

            <p className="mb-0">Inhaber:</p>
            <p className="mb-0">Ahmed Abd El Aal</p>
            <p className="mb-0">Öffentlich bestellter und allgemein beeidigter Dolmetscher und Übersetzer für</p>
            <p>die arabische Sprache Mitglied des BDÜ (Bundesverband der Dolmetscher und Übersetzer)</p>

            <p className="mb-0">Tel.: +49 (0) 341 86087273</p>
            <p className="mb-0">Fax: +49 (0) 341 86087274</p>
            <p>E-Mail: info@kaza-sprachdienste.de</p>

            <p>Steuer-Nr.: 231/200/10743</p>
        </div>

        <div className="row mb-4">
        <h5>Haftung für Inhalte</h5>

       <p> Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
       </p>
        </div>

        <div className="row mb-4">
        
        <h5>Haftung für Links</h5>

        <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>
        </div>

        <div className="row mb-4"> 
        <h5>Urheberrecht</h5>

        <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>
        </div>
        
        <div className="row mb-5">
        <p>Quellenangaben: <a href="https://www.e-recht24.de/muster-disclaimer.html" rel="noreferrer" target="_blank"> Disclaimer eRecht24</a></p>

        <h5>Bildnachweise</h5>

        <p>Grafik Übersetzer - Datei: <a href="https://stock.adobe.com/de/images/ubersetzer-n-laptop-monitor-im-buro-mit-begriff-im-suchfeld-paragraf-und-waage-recht-gesetz-anwalt/290239202" rel="noreferrer" target="_blank" className="text-decoration-none">#290239202</a>  | © Urheber: MQ-Illustrations - Adobe Stock</p>
        <p>Grafik Merci - Datei: <a href="https://stock.adobe.com/de/images/merci-multilingue-bleu-et-dore/182023846" rel="noreferrer" target="_blank" className="text-decoration-none">#182023846</a>  | © Urheber: Trueffelpix - Adobe Stock</p>
        <p>Grafik Translate - Datei: <a href="https://stock.adobe.com/de/images/translate/185400829" rel="noreferrer" target="_blank" className="text-decoration-none">#185400829</a>  | © Urheber: milosducati - Adobe Stock</p>
        </div>
    </div>;
}

export default Impressum;
